"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M43.842 35.724l-7.092-3.553-12.3 6.163a1 1 0 0 1-.9 0l-12.3-6.163-7.092 3.553a.5.5 0 0 0 0 .894l19.394 9.716a1 1 0 0 0 .9 0l19.394-9.716a.5.5 0 0 0-.004-.894z" }),
  React.createElement("path", { d: "M43.842 23.724l-7.092-3.553-12.3 6.163a1 1 0 0 1-.9 0l-12.3-6.163-7.092 3.553a.5.5 0 0 0 0 .894l19.394 9.716a1 1 0 0 0 .9 0l19.394-9.716a.5.5 0 0 0-.004-.894z" }),
  React.createElement("path", { d: "M23.552 22.334L4.158 12.618a.5.5 0 0 1 0-.894l19.394-9.716a1 1 0 0 1 .9 0l19.394 9.716a.5.5 0 0 1 0 .894l-19.398 9.716a1 1 0 0 1-.896 0z" })
);

